/* BCF header — search overlay + mobile menu (SPEC §3A-B / §5).
   Cart is NOT handled here: the cart button uses Horizon's own
   #cart-drawer/toggle binding + <cart-icon> (Phase-2 wiring). This module
   only drives the BCF search overlay, the mobile menu, and their scrim. */
(function () {
  var retiredLedgerPaths = ['/collections/silver-ropes-launch', '/collections/launch-rope-catalog'];
  var assortmentUrl = '/#grid';

  function isRetiredLedgerUrl(value) {
    try {
      return retiredLedgerPaths.indexOf(new URL(value, window.location.origin).pathname.replace(/\/$/, '')) !== -1;
    } catch (_error) {
      return false;
    }
  }

  function isAssortmentUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && url.pathname === '/' && url.hash === '#grid';
    } catch (_error) {
      return false;
    }
  }

  if (retiredLedgerPaths.indexOf(window.location.pathname.replace(/\/$/, '')) !== -1) {
    window.location.replace(assortmentUrl);
    return;
  }

  function rewriteRetiredLedgerLinks(root) {
    root.querySelectorAll('a[href]').forEach(function (link) {
      if (isRetiredLedgerUrl(link.getAttribute('href'))) link.setAttribute('href', assortmentUrl);
    });
  }

  rewriteRetiredLedgerLinks(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteRetiredLedgerLinks(document); }, { once: true });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (isRetiredLedgerUrl(href)) {
      event.preventDefault();
      window.location.assign(assortmentUrl);
      return;
    }

    // A same-page /#grid link can be a no-op when #grid is already in the
    // address bar and the shopper has since scrolled elsewhere. Make the
    // hamburger-menu path deterministic without reloading the homepage.
    if (isAssortmentUrl(href) && window.location.pathname === '/') {
      // The minimal storefront replaces the legacy #grid with its visible
      // four-SKU rail. Prefer that live section while keeping /#grid as the
      // stable public URL used by menus and the empty-cart continuation.
      var grid = document.getElementById('minimal-brand') || document.getElementById('grid');
      if (!grid) return;
      event.preventDefault();
      close();
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#grid');
      window.requestAnimationFrame(function () {
        grid.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    }
  }, true);

  var search = document.getElementById('bcf-search');
  var mmenu = document.getElementById('bcf-mmenu');
  var scrim = document.getElementById('bcf-scrim');
  if (!search && !mmenu) return;

  // JS present: un-hide the fixed panels (kept off-screen by CSS transforms).
  [search, mmenu, scrim].forEach(function (el) {
    if (el) { el.hidden = false; el.setAttribute('aria-hidden', 'true'); }
  });

  var openEl = null;

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function open(el) {
    if (!el) return;
    close(); // ensure only one open
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.classList.add('on'); }
    lockScroll(true);
    openEl = el;
    if (el === search) {
      var input = document.getElementById('bcf-search-input');
      if (input) { setTimeout(function () { input.focus(); }, 60); }
    }
  }

  function close() {
    [search, mmenu].forEach(function (el) {
      if (el) { el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); }
    });
    if (scrim) { scrim.classList.remove('on'); }
    lockScroll(false);
    openEl = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bcf-search-open]')) { e.preventDefault(); open(search); }
    else if (t.closest('[data-bcf-menu-open]')) { e.preventDefault(); open(mmenu); }
    else if (t.closest('[data-bcf-search-close]') || t.closest('[data-bcf-menu-close]') || t.closest('[data-bcf-close]')) {
      e.preventDefault(); close();
    }
  });

  // Close the mobile menu when a link inside it is followed.
  if (mmenu) {
    mmenu.addEventListener('click', function (e) {
      if (e.target.closest('a')) { close(); }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openEl) { close(); }
  });
})();
